import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useStateManager } from "@bcm-dev/bcms-vite";
import Classes, { Account, CheckingAccount, LOCAccount, StopPayment } from "model";
import React from "react";

import { PageContentView } from 'components/shared';
import PageContainer from 'components/shared/containers/PageContainer';
import StopPaymentHistoryWidget from "components/shared/widgets/StopPaymentHistoryWidgets/StopPaymentHistoryWidget";
import "./styles.css";
import "./mobile.css";


/**
 * @function StopPaymentHistoryPage
 * @return {React.Component}
 * @exported true
 * @description The main component for StopPaymentHistoryPage
 */
export default function StopPaymentHistoryPage(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);

    const data = { ...getDefaultPageData(), ...props.data ?? {} };
    const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };

    const getFilteredStopPayments = accountID => StopPayment.initAll().filter(item => item.account.id === accountID);

    const controller = (state, setState) => ({
        data: state.data,
        ui: state.ui,

        onChange: prop => val => {
            BCMSStateManagerCRUD.init(state)
            .update([ "data", prop ], val)
            .submit(setState);
        },

        onClick: evt => {
            BCMSStateManagerCRUD.init(state)
                .update([ "ui", "showPayments" ], true)
                .update([ "data", "payments" ], getFilteredStopPayments(state.data.account.id))
                .submit(setState);
        }
    });

    return (
        <PageContainer className="stop-payment-history" state={ { data, ui } } controller={ controller }>
            <StopPaymentHistoryContent />
        </PageContainer>
    );
}

export const getDefaultPageData = (accountID, accounts, payments, allStopPayments) => {
    const account = accountID ? Account.initByType(accountID) : Account.getDefaultBrandedAccountByType("checking");
    let _accounts = Account.hasLOCAccounts() ? LOCAccount.initAll() : CheckingAccount.initAll();
    _accounts = accounts ?? _accounts;
    let _payments = StopPayment.initAll().filter(item => item.account.id === account.id);
    _payments = payments ?? _payments;
    const _allStopPayments = allStopPayments ?? StopPayment.initAll();

    return {  
        account, 
        accounts: _accounts, 
        payments: _payments, 
        allStopPayments: _allStopPayments 
    };
};

export const getDefaultPageUI = () => ({
    showPayments: false,
    accountSelect: { isActive: false }
});

function StopPaymentHistoryContent(props) {
    const { data, ui, onChange, onClick } = useStateManager();

    return (
        <PageContentView>
            {/* "useStateManager()"" is used in this widget to get data in this page. */}
            <StopPaymentHistoryWidget data={ data } ui={ ui } onChange={ onChange } onClick={ onClick } />
        </PageContentView>
    );
}

